import React from "react";
import TextLabel from "../../Controls/TextLabel.mjs";
import {Button, Form, Input} from "reactstrap";
import SelectPlayer from "../../Controls/SelectPlayer.mjs";
import "./Authentication.css";
import HtmlLabel from "../../Controls/HtmlLabel.mjs";

const G = window.glob;

const PasswordField = class extends React.Component {
	constructor(props) {
		super(props);
		this.uid = G.generateUid('PasswordField');
	}
	render() {
		return (
			<Input
				className={this.props.className ?? ""}
				id={ this.props.id || this.uid }
				name={ this.props.name || "password" }
				autoFocus={ !! this.props.autoFocus }
				disabled={ !! this.props.disabled }
				placeholder={ this.props.placeholder ?? G.label("Password") }
				type="password"
				minLength={ this.props.minLength ?? 3 }
				value={ this.props.value }
				onChange={ (e)=>{ this.props.onChange(e.target.value); }}
			/>
		)
	}
}

const OtpField = class extends React.Component {
	constructor(props) {
		super(props);
		this.uid = G.generateUid('OtpField');
	}
	render() {
		return (
			<Input
				className={this.props.className ?? ""}
				id={ this.props.id || this.uid }
				name={ this.props.name || "password" }
				autoFocus={ !! this.props.autoFocus }
				disabled={ !! this.props.disabled }
				placeholder={ this.props.placeholder ?? G.label("OTP") }
				type="text"
				minLength={ this.props.minLength ?? 3 }
				size={5}
				value={ this.props.value }
				onChange={ (e)=>{ this.props.onChange(e.target.value); }}
			/>
		)
	}
}

const Authentication = class extends React.Component {
	constructor(props) {
		super(props);
		this.state={
			username: props.username,
			password: ''
		};
		this.playerSelected = this.playerSelected.bind(this);
		this.goahead = this.goahead.bind(this);
		this.authenticate = this.authenticate.bind(this);
		this.uid = G.generateUid('Authentication');
		if ( props.username ) {
			setTimeout( ()=>{ this.playerSelected( props.username );}, 100 );
		}
	}
	playerSelected(un) {
		const newstate = { username: un, otpsent: false };
		const players = G.getStatus('Players');
		const player = players.find( p => ( p.id === un ));
		newstate.otp = player?.otp ?? false;
		newstate.password = '';
		newstate.playername = player?.name ?? false;
		this.setState(newstate);
	}
	async authenticate() {
		await this.setState({ loading: true });
		G.api(
			{ entity:"startup",operation:"auth"},
			{ username: this.state.username, password: this.state.password }
		).then( (r) => {
			setTimeout( ()=>{
				this.props.onDone( r );
			});
		}).catch( (e) => {
			console.warn(e);
			this.setState({ password: '' });
		}).finally( ()=> {
			this.setState({ loading: false });
		});
	}
	async goahead() {
		if ( ! this.state.username ) return;
		if ( ! this.state.otp ) {
			if (this.state.password.length > 2) return this.authenticate();
		}
		if ( ! this.state.otpsent ) {
			await this.setState({ loading: true });
			G.api(
				{entity: 'startup', operation: 'otp'},
				{ player: this.state.username }
			).then(( results ) => {
				this.setState({otpsent: results?.message });
			}).catch( e => {
				console.error(e);
			}).finally( ()=>{
				this.setState({ loading: false });
			});
			return;
		}
		if (this.state.password.length > 2) this.authenticate();
	}
	render() {
		return (
			<div className={"Authentication"} id={this.uid}>
				{ this.props.header || (
					<h4 key={"AuthenticationTitle"}>
						<TextLabel value={"Authentication"}/>
					</h4>
				)}
				<Form
					key={"AuthenticationForm"}
					onSubmit={(e) => {
						e.preventDefault();
						this.goahead();
					}}
				>
					{
						this.state.otpsent ? (
							<Input
								name={ "username" }
								disabled={ true }
								value={ `${(this.state.otp||"").replace(/@(.).*(.[^.]+)$/,"@$1…$2")} [${this.state.playername}]` }
							/>
						) : (
							<SelectPlayer
								value={ this.state.username ? this.state.username : null  }
								autoFocus={ !this.state.username }
								players={ G.getStatus('Players').filter( p => ! p.ext) }
								noOptionsMessage={ String(<TextLabel value={"NoUsers"} />) }
								onChange={(o) => {
									this.playerSelected( o.value );
								}}
							/>
						)
					}
					{ this.state.username && (
						this.state.otp ? (
							this.state.otpsent ? (
								<div className={"OTP"}>
									<OtpField
										key={"AuthenticationOtp" + (!this.state.username)}
										autoFocus={!!this.state.username}
										disabled={!this.state.username}
										value={this.state.password}
										onChange={(p) => {
											this.setState({password: p});
										}}
									/>
									<em>
										<TextLabel value={"CheckJunkMail"}/>
									</em>
								</div>
							) : (
								<div className={"otpMessage"}>
									<HtmlLabel value={"OtpMessage"} params={{
										name: this.state.playername ? `“${this.state.playername}”` : undefined,
										email: `“<b>${(this.state.otp||"").replace(/@(.).*(.[^.]+)$/,"@$1…$2")}</b>”`
									}}/>
								</div>
							)
						) : (
							<PasswordField
								key={"AuthenticationPassword" + (!this.state.username)}
								className={"Password"}
								autoFocus={!!this.state.username}
								disabled={!this.state.username}
								value={this.state.password}
								onChange={(p) => {
									this.setState({password: p});
								}}
							/>
						)
					)}
					<div className={"Buttons"} key={"AuthenticationButtons"}>
						<Button
							key={"AuthenticationCancel"}
							className={"btn-icon Cancel"}
							color={"danger"}
							onClick={() => {
								this.props.onCancel();
							}}
						>
							<i><TextLabel value={"back"} lang={"icon"}/></i>
							<b><TextLabel value={"Cancel"}/></b>
						</Button>
						<Button
							key={"AuthenticationSubmit"}
							hidden={ this.state.password.length < 3 }
							type={"submit"}
							className={"btn-icon OK"}
							color={"success"}
						>
							<b><TextLabel value={"OK"}/></b>
							<i><TextLabel value={"forward"} lang={"icon"}/></i>
						</Button>
						<Button
							key={"AuthenticationOtp"}
							hidden={ (! this.state.otp ) || this.state.otpsent }
							type={"submit"}
							className={"btn-icon OK"}
							color={"success"}
						>
							<b><TextLabel value={"Send OTP"}/></b>
							<i><TextLabel value={"forward"} lang={"icon"}/></i>
						</Button>
					</div>
				</Form>
				{this.state.loading ? <div className={"curtain"}/> : ''}
			</div>
		);
	}
}

export default Authentication;
